/*
 * Created on Tue Jun 15 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

import { Link, useHistory, useParams } from "react-router-dom";
import React, { useState, useEffect, useRef, useReducer, forwardRef, useImperativeHandle } from 'react';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import parse1 from 'html-react-parser';
import { FormButtons, SignupBgOne, CloseButton } from '../components';
import { useWindowDimensions } from "../utils/helpers";
// import axios from "axios";

import faIcon from "../assets/images/icons/fa-icon.png";
import triangle from "../assets/images/icons/exclamation-triangle.png";
import preloader from "../assets/images/preloaders/03-preloader-6px-7D0D39.gif";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { IoLocationSharp } from "react-icons/io5";
import { RadioButtonUnchecked, RadioButtonChecked } from '@material-ui/icons';

import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import Modal from 'react-bootstrap/Modal';
import parse2 from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { Radio, RadioGroup, FormControlLabel, FormGroup, Checkbox } from '@material-ui/core';

import { CountriesNameCode } from '../utils/countries'

import { 
    images, 
    mobileImages, 
    AccountTypes, 
    FashionArtistProfessions
} from '../constants'

import { 
    registerUser,
    checkEmailExist
} from "../apis/user.api";
import { updateAuthorizationHeader } from '../apis/api';

import useInvite from 'hooks/invite.hook'
import useAuth from 'hooks/auth.hook'

const accounts = FashionArtistProfessions;

/*
yup.addMethod(yup.string, "uniqueEmail", function (errorMessage) {
    return this.test('email', errorMessage, function (value) {
        const { path, createError } = this;

        return (
            (value && !fakeEmails.includes(value.toLowerCase())) ||
            createError({ path, message: <span>Oops! This email is taken. <Link to="/login">Log in</Link> instead?</span> })
        );
    });
});
*/


yup.addMethod(yup.mixed, 'uniqueEmail', function(args) {
    const message = args
    return this.test('email', message, function(value) {
        const { path, createError } = this;
        return new Promise((resolve, reject) => {
            checkEmailExist(value).then(res => {
                if (res.data.result)
                    reject(createError({ path, message: <span>Oops! This email is taken. <Link to="/login">Log in</Link> instead?</span> }))
                else
                    resolve(true)
            })
        })
    })
})

const schema = yup.object().shape({
    firstName: yup
        .string()
        .required('*Required'),
    lastName: yup
        .string()
        .required('*Required'),
    email: yup
        .string()
        .required('*Required')
        .email('Oops! Invalid email address')
        .uniqueEmail(),
    password: yup
        .string()
        .required('*Required')
        .min(7, 'Oops! We hate this too. But password needs a minimum of 7 characters, with at least 1 alphabet and 1 numerical digit.')
        .matches(/([\s\S])([1-9])/, 'Oops! We hate this too. But password needs a minimum of 7 characters, with at least 1 alphabet and 1 numerical digit.'),
    countryCode: yup
        .string()
        .required('*Required'),
    // gender: yup
    //     .string()
    //     .nullable()
    //     .required('*Required'),
    agreeToTerms: yup
        .string()
        .nullable()
        .required('*Required')
});

export function Artist({ displayAll, passDisplayAll, code }) {
    
    const mounted = useRef(false);
    const arrayIsFilled = useRef(false);

    // const [artist, setArtist] = useState();
    const [artistArr, setArtistArr] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [move, setMove] = useState(false);
    const [display, setDisplay] = useState(false);
    const [displayNone, setDisplayNone] = useState(true);
    const [opacity, setOpacity] = useState(1);
    const { windowWidth, isMobile } = useWindowDimensions();
    
    setTimeout(() => { setDisplay(true) }, 2000);

    const onSetOpacity = (op) => setOpacity(op);
    const onSetDisplayNone = (d) => {
        setMove(!d);
        setDisplay(!d);
        setDisplayNone(d);
        passDisplayAll(!d);
        onReset();
    }

    (artistArr.length > 0) ? arrayIsFilled.current = true : arrayIsFilled.current = false;

    /*
    useEffect(() => {
        if (mounted.current) {
            setArtistArr([...artistArr, artist]);
        }
        else mounted.current = true;
        // eslint-disable-next-line
    }, [artist]);
    */
    useEffect(() => {
        if (artistArr.length === 3) {
            setDisabled(true);
        }
    }, [artistArr]);
    useEffect(() => {
        displayAll ? setDisplayNone(false) : setDisplayNone(true);
    }, [displayAll]);

    function onReset() {
        // setArtist();
        setArtistArr([]);
        setDisabled(false);
        mounted.current = false;
    }

    return (
        <div id="signupFa" className={`signup-above-menu ${displayNone ? 'd-none' : ''}`}>
            {windowWidth <= 1030 ?
                <>
                    <CloseModal passOpacity={onSetOpacity} passDisplayNone={onSetDisplayNone} />
                    <AccountLabel icon={faIcon} type="artist" />
                </>
                : null}
            <div id="slide" className={move ? 'move' : ''}>
                <div className="scroll-container">
                    <SignupBgOne
                        desktop={images['fa-bg.jpg']}
                        mobile={mobileImages['fa-bg.jpg']}
                    />
                    {windowWidth > 1030 ? <CloseModal passOpacity={onSetOpacity} passDisplayNone={onSetDisplayNone} /> : null}
                    <div id="faAccount" className="row" style={{ opacity: opacity }}>
                        {windowWidth > 1030 ?
                            <div className="form-header col-6 col-sm-6 col-md-6 col-lg-6">
                                <AccountLabel icon={faIcon} type="artist" />
                                <p className="header pink-text">i'm a fashion:</p>
                                <p id="instructions" className={arrayIsFilled.current ? '' : 'd-none'}>You can select 2 more account types if you<br /> have secondary fashion professions. Click<br /> Reset to refresh your selections or Confirm<br /> to continue.</p>
                            </div>
                            :
                            <div className="form-header col mobile">
                                <p className="header pink-text">i'm a fashion:</p>
                                <p id="instructions" className={arrayIsFilled.current ? '' : 'd-none'}>You can select 2 more account types if you have secondary fashion professions. Click Reset to refresh your selections or Confirm to continue.</p>
                            </div>
                        }
                        <div id="checkboxes" className={windowWidth > 1030 ? "col-6 col-sm-6 col-md-6 col-lg-6" : "col"}>
                            {accounts.map(({ value, label }, index) =>
                                <FormGroup key={index} className="radio-buttons">
                                    <FormControlLabel
                                        disabled={arrayIsFilled.current && disabled && !artistArr.includes(value) ? true : false}
                                        control={
                                            <Checkbox
                                                icon={<RadioButtonUnchecked opacity={arrayIsFilled.current && value !== artistArr[0] ? 0.5 : 1} />}
                                                checkedIcon={<RadioButtonChecked opacity={arrayIsFilled.current && value !== artistArr[0] ? 0.5 : 1} />}
                                                value={value}
                                                checked={arrayIsFilled.current && artistArr.includes(value)}
                                                onChange={() => {
                                                    //setArtist(value)
                                                    if (!artistArr.includes(value)) {
                                                        setArtistArr([
                                                            ...artistArr,
                                                            value
                                                        ])
                                                    }
                                                }}
                                            />
                                        }
                                        label={label}
                                    />
                                </FormGroup>
                            )}
                        </div>
                    </div>
                    <FormButtons
                        opacity={display ? opacity : 0}
                        disabled={artistArr.length === 0}
                        reset={onReset}
                        submit={() => setMove(true)}
                    />
                </div>
            </div>
            <Slide2
                onMove={move}
                windowWidth={windowWidth}
                isMobile={isMobile}
                passDisplayNone={onSetDisplayNone}
                code={code}
                artistArr={artistArr}
            />
        </div>
    );
}

function Slide2({ onMove, windowWidth, isMobile, passDisplayNone, code, artistArr }) {
    const scrollRef = useRef();
    const formRef = useRef();

    const [move, setMove] = useState(false);
    const [formHasValue, setFormHasValue] = useState(false);
    const [layoutHeight, setLayoutHeight] = useState(0);
    const [opacity, setOpacity] = useState(1);
    const [formData, setFormData] = useState([]);
    const [footerStyle, setFooterStyle] = useState({
        position: 'absolute',
        top: 0
    });

    const getFormHasValue = (formValue) => setFormHasValue(formValue);
    const getFormData = (formData) => setFormData(formData);
    const onKeyboardShow = () => {
        setFooterStyle({
            position: 'relative',
            top: '6rem'
        })
    };
    const onKeyboardHide = () => {
        setFooterStyle({
            position: 'absolute',
            top: layoutHeight - 70
        });
    };
    const onSetOpacity = (op) => setOpacity(op);
    const onSetDisplayNone = (d) => {
        passDisplayNone(d);
        setMove(!d);
        formRef.current.reset();
    };

    useEffect(() => {
        setLayoutHeight(window.innerHeight);
        setFooterStyle({
            top: window.innerHeight - 70
        });
    }, []);
    useEffect(() => {
        onMove ? setMove(true) : setMove(false);
    }, [onMove]);
    useEffect(() => {
    }, [formData]);

    return (
        <div id="slide2" className={move ? 'move' : ''}>
            <div ref={scrollRef} className="scroll-container">
                <SignupBgOne
                    desktop={images['fa-bg2.jpg']}
                    mobile={mobileImages['fa-bg2.jpg']}
                />
                {windowWidth > 1030 ? <CloseModal passOpacity={onSetOpacity} passDisplayNone={onSetDisplayNone} /> : null}
                <div id="faAccount" className="row" style={{ opacity: opacity }}>
                    {windowWidth > 1030 ?
                        <div className="form-header col-7 col-sm-7 col-md-7 col-lg-7">
                            <AccountLabel icon={faIcon} type="artist" />
                            <p className="header pink-text">let's get to know<br /> one another better.</p>
                        </div>
                        :
                        <div className="form-header row m-0">
                            <p className="header pink-text">let's get to know<br /> one another better.</p>
                        </div>
                    }
                    <Form
                        ref={formRef}
                        passScrollRef={scrollRef}
                        windowWidth={windowWidth}
                        passFormHasValue={getFormHasValue}
                        passFormData={getFormData}
                        triggerKeyboardShow={onKeyboardShow}
                        triggerKeyboardHide={onKeyboardHide}
                        code={code}
                        artistArr={artistArr}
                    />
                </div>
                <FormButtons
                    opacity={opacity}
                    className={move ? "" : "d-none"}
                    disabled={!formHasValue}
                    reset={() => formRef.current.reset()}
                    submit={() => formRef.current.submit()}
                    formData={formData}
                    preloader={preloader}
                    style={{
                        position: isMobile ? footerStyle.position : null,
                        top: isMobile ? footerStyle.top : null
                    }}
                />
            </div>
        </div>
    )
}

const defaultValues = {
    agreeToTerms: ''
}

export const Form = forwardRef(({ 
    lover, passScrollRef, windowWidth, 
    passFormHasValue, passFormData, triggerKeyboardShow, 
    triggerKeyboardHide, code, artistArr }, ref) => {
    const { isSuccess: getInviteSuccess, data: getInviteData } = useInvite()
    
    const { register, handleSubmit, setValue, reset, watch, control, clearErrors, formState: { errors, isSubmitted } } = useForm({
        // mode: "onChange",
        shouldFocusError: false,
        resolver: yupResolver(schema),
        defaultValues
    });
    const { setSession } = useAuth()

    const history = useHistory();

    const formRef = useRef();

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [showPopup, togglePopup] = useState(false);
    const [showIcon, setShowIcon] = useState(false);
    const [passwordHovered, setPasswordHovered] = useState(false);
    const [passwordFocused, setPasswordFocused] = useState(false);
    const [countries, setCountries] = useState([]);
    const [emptyFields, setEmptyFields] = useState([]);
    const [offsetBottom, setOffsetBottom] = useState(0);

    const [showPassword, togglePassword] = useReducer(
        showPassword => !showPassword,
        false
    );
    const [clearLocationInput, toggleLocationInput] = useReducer(
        clearLocationInput => !clearLocationInput,
        false
    );

    let tempEmptyFields = [];

    useImperativeHandle(ref, () => ({
        reset() {
            onReset()
        },
        submit() {
            handleSubmit(onSubmit)()
        }
    }))

    watch((data) => {
        if (!Object.values(data).some(val => val)) {
            passFormHasValue(false);
        }
        else passFormHasValue(true);
    })

    const onInputBlur = (e) => {
        if (e.target.value) {
            setValue(e.target.name, e.target.value, { shouldValidate: true })
        }
        else {
            if (emptyFields.length === 0) {
                clearErrors(e.target.name);
                setValue(e.target.name, e.target.value);
            }
        }
    }
    const onReset = () => {
        reset(defaultValues);
        toggleLocationInput(clearLocationInput);
        setEmptyFields([]);
        passFormHasValue(false);
    };
    const onSubmit = (data, e) => {
        passFormData(data);

        if (!lover) {
            if (artistArr.length > 0) {
                data.primaryProfession = artistArr.shift()
            }
            if (artistArr.length > 0) {
                data.secondaryProfessions = artistArr
            }
        }

        registerUser({
            ...data,
            accountType: lover ? AccountTypes.FashionLover : AccountTypes.FashionArtist,
            code
        })
        .then(res => {
            // console.log(res)
            localStorage.setItem(`${process.env.REACT_APP_HOST}:user`, JSON.stringify(res.data.accessToken));
            updateAuthorizationHeader(res.data.accessToken.token)
            // get profile
            setSession({
                profile: res.data.user,
                accessToken: res.data.accessToken.token
            })
            history.push({pathname: '/home', state: {from: 'signup'}});
        })
        .catch(err => console.log(err))
    };
    const addEmptyFieldStyle = fieldName => {
        // if (fieldName === 'gender' || fieldName === 'agreeToTerms') {
        if (fieldName === 'agreeToTerms') {
            return emptyFields.includes(fieldName) ? 'pink-text' : '';
        }
        return emptyFields.includes(fieldName) ? 'empty-field' : '';
    };
    const filterOptions = createFilterOptions({
        matchFrom: 'start',
        stringify: option => option.name,
    });

    useEffect(() => {
        const countriesList = CountriesNameCode();

        setCountries(countriesList);
        setIsLoaded(true);

        /*
        // fetch("https://restcountries.eu/rest/v3.1/all")
        fetch("https://restcountries.com/v2/all?fields=name")
            .then(res => res.json())
            .then(
                (result) => {
                    setIsLoaded(true);
                    setCountries(result);
                },
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
        */
    }, []);
    useEffect(() => {
    offsetBottom < 70 ? triggerKeyboardShow() : triggerKeyboardHide();
        // eslint-disable-next-line
    }, [offsetBottom]);
    // eslint-disable-next-line
    useEffect(() => {
        let scrollBottom = passScrollRef.current.getBoundingClientRect().bottom;
        let formBottom = formRef.current.getBoundingClientRect().bottom;
        setOffsetBottom(scrollBottom - formBottom);
    });
    useEffect(() => {
        if (isSubmitted) {
            for (let [key, value] of Object.entries(errors)) {
                if (value.type === 'required') {
                    tempEmptyFields.push(key);
                }
            }
            setEmptyFields(tempEmptyFields);
        }
        // eslint-disable-next-line
    }, [isSubmitted]);

    useEffect(() => {
        if (getInviteSuccess && getInviteData) {
            const { email, name } = getInviteData
            setValue('email', email)
            setValue('firstName', name)
        }
    }, [getInviteSuccess, getInviteData])

    console.log(errors)

    return (
        <form
            ref={formRef}
            id={lover ? "flForm" : "faForm"}
            className={windowWidth > 1030 ? "col-5 col-sm-5 col-md-5 col-lg-5 signup-form" : "signup-form row m-0"}
            autoComplete="off"
            noValidate="novalidate"
            onSubmit={handleSubmit(onSubmit)}
        >
            <div className="form-group">
                <input
                    className={errors.firstName ? 'form-control pink-border ' + addEmptyFieldStyle('firstName') : 'form-control'}
                    placeholder="First name"
                    autoComplete="firstName"
                    {...register("firstName")}
                />
                <span className="error-msg pink-text">{errors.firstName?.message}</span>
            </div>
            <div className="form-group">
                <input
                    className={errors.lastName ? 'form-control pink-border ' + addEmptyFieldStyle('lastName') : 'form-control'}
                    placeholder="Last name"
                    autoComplete="off"
                    {...register("lastName")}
                />
                <span className="error-msg pink-text">{errors.lastName?.message}</span>
            </div>
            <div className="form-group">
                <input
                    type="email"
                    className={errors.email ? 'form-control pink-border ' + addEmptyFieldStyle('email') : 'form-control'}
                    placeholder="Email"
                    autoComplete="firstName"
                    {...register("email")}
                    onBlur={(e) => onInputBlur(e)}
                    onChange={(e) => errors.email?.message.type === 'span' || errors.email?.message.includes('Invalid') ? onInputBlur(e) : null}
                />
                <span className="error-msg pink-text">{errors.email?.message}</span>
            </div>
            <div
                className={`
                    form-group password 
                    ${passwordHovered ? "hovered" : ""} 
                    ${errors.password ? addEmptyFieldStyle('password') : ""}
                `}
                style={{ background: passwordFocused ? 'none' : null }}
                onMouseEnter={() => setPasswordHovered(true)}
                onMouseLeave={() => setPasswordHovered(false)}
            >
                <input
                    type={showPassword ? 'text' : 'password'}
                    className="form-control"
                    placeholder="Password"
                    autoComplete="off"
                    {...register("password")}
                    onBlur={(e) => { setPasswordFocused(false); onInputBlur(e) }}
                    onFocus={() => { setPasswordFocused(true); setPasswordHovered(false) }}
                    onChange={(e) => {
                        setShowIcon(true);
                        return errors.password && !errors.password?.message.includes('Required') ? onInputBlur(e) : null
                    }}
                />
                <span className={errors.password ? "password-border pink-border" : "password-border"} style={{ borderWidth: passwordFocused ? '2px' : null }}></span>
                <span className="password-icon" onMouseEnter={() => setPasswordHovered(false)} onMouseLeave={() => setPasswordHovered(true)}>
                    <IoMdEye className={showPassword || !showIcon ? 'd-none' : 'float-right'} onClick={togglePassword} />
                    <IoMdEyeOff className={showPassword ? 'float-right' : 'd-none'} onClick={togglePassword} />
                </span>
            </div>
            <span className="error-msg pink-text">{errors.password?.message}</span>
            <div className="form-group autocomplete">
                <IoLocationSharp className="float-left" />
                <Controller
                    name="countryCode"
                    control={control}
                    render={({ field }) => (
                        <Autocomplete
                            {...field}
                            key={clearLocationInput}
                            open={showPopup}
                            onClose={() => togglePopup(false)}
                            onChange={(e, value) => field.onChange(value?.value ?? '')}
                            onInputChange={() => togglePopup(true)}
                            options={countries}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    className={errors.countryCode ? addEmptyFieldStyle('countryCode') : ''}
                                    placeholder="Location"
                                />
                            )}
                            filterOptions={filterOptions}
                            renderOption={(option, { value }) => {
                                const matches = match(option.name, value);
                                const parts = parse2(option.name, matches);
                                return (
                                    <div
                                        onMouseEnter={(e) => {
                                            if (e.target.children.length > 1) {
                                                e.target.children[0].style.color = '#EC0F69';
                                                e.target.children[1].style.color = '#EC0F69';
                                            }
                                            if (e.target.children[0] && e.target.children.length <= 1) {
                                                e.target.children[0].style.color = '#EC0F69';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (e.target.children.length > 1) {
                                                e.target.children[0].style.color = '#FFF';
                                                e.target.children[1].style.color = '#BDBDBD';
                                            }
                                            if (e.target.children[0] && e.target.children.length <= 1) {
                                                e.target.children[0].style.color = '#BDBDBD';
                                            };
                                        }}
                                    >
                                        {parts.map((part, index) => (
                                            <span key={index} style={{ color: part.highlight ? '#FFF' : '#BDBDBD' }}>
                                                {part.text}
                                            </span>
                                        ))}
                                    </div>
                                );
                            }}
                        />
                    )}
                />
            </div>
            <div className="form-group">
                <span className="error-msg pink-text">
                    {error?.message || errors.countryCode?.message || (!isLoaded ? 'Loading...' : '')}
                </span>
            </div>
            <Controller
                name="agreeToTerms"
                control={control}
                render={({ field }) => (
                    <RadioGroup
                        className="radio-buttons inline terms"
                        {...field}
                    >
                        <FormControlLabel
                            className={errors.agreeToTerms ? addEmptyFieldStyle('agreeToTerms') : ''}
                            value="true"
                            control={<Radio />}
                            label={parse1("Yes, I agree to the <a class='footer-link p-0' href='/here/terms' target='_blank'>Terms & Conditions</a> of itch.")}
                        />
                    </RadioGroup>
                )}
            />
            <span className="error-msg pink-text">{errors.agreeToTerms?.message}</span>
        </form>
    )
})

export function CloseModal({ passOpacity, passDisplayNone }) {
    const getOpacity = (op) => passOpacity(op);
    const onSetDisplayNone = (d) => passDisplayNone(d);

    const [showModal, toggleModal] = useReducer(
        showModal => !showModal,
        false
    );

    return (
        <>
            <CloseButton closeModal={toggleModal} passOpacity={getOpacity} />
            <Modal
                backdropClassName="fa-modal-backdrop"
                dialogClassName="fa-modal-dialog"
                contentClassName="fa-modal-content"
                show={showModal}
                onHide={toggleModal}>
                <Modal.Header>
                    <img src={triangle} alt="exclaimation triangle" />
                </Modal.Header>
                <Modal.Body className="fa-modal-body">
                    <p className="pink-text">Oops!</p>
                    <p className="grey-text first">Your account hasn't been created.</p>
                    <p className="grey-text">Close anyway?</p>
                </Modal.Body>
                <Modal.Footer className="footer-buttons-div">
                    <button className="footer-buttons pink-text yes" onClick={() => { onSetDisplayNone(true); toggleModal() }}>Yes</button>
                    <button className="footer-buttons pink-text no" onClick={toggleModal}>No</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export function AccountLabel({ icon, type }) {
    return (
        <div id="accountLabel">
            <img src={icon} alt={`fashion ${type} icon`} />
            <span className="pink-text">fashion {type} account</span>
        </div>
    )
}
